'use client';

import { useTranslations } from 'next-intl';
import { useClearRefinements } from 'react-instantsearch';

import Text from '@commons/components/Text';

import styles from './ClearFilters.module.scss';

/** Clears the active search refinements. */
const ClearFilters = () => {
  const t = useTranslations('search');
  const { refine } = useClearRefinements();

  return (
    <button type="button" onClick={refine} className={styles.button}>
      <Text as="span" level="p" marginBottom="none" className={styles.label}>
        {t('filters.clearFilters')}
      </Text>
    </button>
  );
};

export default ClearFilters;
